import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { CourseLmsProfileType } from 'enum'
import CourseForm from 'components/ui/forms/course/CourseForm'
import { NewCourse } from 'models/course.model'
import * as fromActions from 'store/actions/courses.action'
import { OnSubmitValues } from 'components/ui/forms/course/types'
import { useAccess } from 'contexts/AccessContext'
import Wrapper from 'components/reusables/wrapper'
import { getSynchronousCourse } from '../utils'

export const New: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    permissions: { all, canManageCourses },
    loading,
  } = useAccess()

  useEffect(() => {
    if (loading) return
    if (!(all || canManageCourses)) window.location.href = '/'
  }, [loading, all, canManageCourses])

  const handleSubmit = (values: OnSubmitValues, onlySave: boolean) => {
    let coursesLmsProfilesAttributes: any[] = []
    if (values.requiredProfiles)
      coursesLmsProfilesAttributes = values.requiredProfiles.map(
        ({ value }: any) => ({
          lmsProfileId: value,
          kind: CourseLmsProfileType.Required,
        })
      )
    if (values.optionalProfiles)
      coursesLmsProfilesAttributes = [
        ...coursesLmsProfilesAttributes,
        ...values.optionalProfiles.map(({ value }: any) => ({
          lmsProfileId: value,
          kind: CourseLmsProfileType.Optional,
        })),
      ]

    const synchronousCourse = getSynchronousCourse(values)

    const course = NewCourse({
      name: values.name,
      description: values.description,
      courseType: values.courseType,
      state: values.state?.value,
      startDate: values.startDate ? String(values.startDate) : '',
      untilDate: values.untilDate ? String(values.untilDate) : '',
      banner: values.banner,
      thumbnail: values.thumbnail,
      coursesLmsProfilesAttributes: coursesLmsProfilesAttributes,
      directChiefApproval: values.directChiefApproval,
      invitationNotification: values.invitationNotification,
      canGenerateCertificate: values.canGenerateCertificate,
      reminderNotification: values.reminderNotification,
      reminderNoStartCourseNotification:
        values.reminderNoStartCourseNotification,
      synchronousCourse: synchronousCourse,
      hours: values.hours,
      canRestart: values.canRestart,
      integrations: values.integrations,
    })

    dispatch({
      type: fromActions.CREATE_COURSE,
      payload: { course, onlySave, history },
    })
  }

  return (
    <Wrapper shadow={true}>
      <h1>{t('administration.courses.new.title')}</h1>
      <CourseForm onSubmit={handleSubmit} />
    </Wrapper>
  )
}

export default New
